<template>
  <crud-form
    v-model="payload"
    :request-class="requestClass"
    page-title="Visualizar informações"
    :remove-buttons="true"
    :navigate-back-route="backRoute"
    :total-group="1"
  >
    <template slot="group-1">
      <form-group>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:id"
              v-model="payload.id"
              :loading="loading"
              label="Código"
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-date
              id="input:createdAt"
              v-model="payload.createdAt"
              :loading="loading"
              label="Data de criação"
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:clientName"
              v-model="payload.clientName"
              :loading="loading"
              label="Cliente"
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-mask
              id="input:clientDocument"
              v-model="payload.clientDocument"
              :loading="loading"
              label="Documento"
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:storeId"
              v-model="storeName"
              :loading="storeLoading"
              label="Loja"
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:productId"
              v-model="productName"
              :loading="productLoading"
              label="Produto"
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:userSystemId"
              v-model="userName"
              :loading="userLoading"
              label="Usuário"
              disabled
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import LojaRequest from 'App/client/store/StoreRequest';
import ProdutoRequest from 'Modules/contacard/produto/product/ProdutoRequest';
import AntiFraudRequest from 'Modules/contacard/limits/antiFraud/AntiFraudRequest';

export default {
  name: 'AntiFraudForm',
  components: { CrudForm, FormGroup },
  mixins: [ServiceMixin],
  data: () => ({
    requestClass: AntiFraudRequest,
    requestStore: LojaRequest,
    requestProduct: ProdutoRequest,
    requestUser: {
      get: (v) => Promise.resolve(v),
    },
    backRoute: 'antiFraud.list',
    storeLoading: false,
    userLoading: false,
    productLoading: false,
    loading: false,
    storeName: '',
    productName: '',
    userName: '',
    payload: {
      userSystemId: '',
      clientId: '',
      storeId: '',
      clientName: '',
      clientDocument: '',
      transaction: '',
      productId: '',
      id: '',
      createdAt: '',
    },
  }),
  computed: {
    getStoreId() {
      return this.payload.storeId;
    },
    getProductId() {
      return this.payload.productId;
    },
    getUserId() {
      return this.payload.userSystemId;
    },
  },
  watch: {
    'payload.id': {
      immediate: true,
      handler(id) {
        if (id) {
          this.getData();
        }
      },
    },
  },
  methods: {
    getData() {
      this.getStoreName();
      this.getProductName();
      this.getUserName();
    },
    getStoreName() {
      this.handleStoreLoading();
      this.makeStoreRequest();
    },
    handleStoreLoading() {
      this.storeLoading = !this.storeLoading;
    },
    makeStoreRequest() {
      this.callService(
        this.requestStore.get(
          this.getStoreId,
        ),
        this.setStoreName,
        this.makeSwalConfig(
          'Falha ao buscar nome da loja!',
        ),
      );
    },
    setStoreName(response) {
      this.handleStoreLoading();
      if (this.hasData(response)) {
        this.storeName = response.data.nomLoja;
      } else {
        this.storeName = this.getStoreId;
      }
    },
    hasData(response) {
      return response && response.data;
    },
    makeSwalConfig(message) {
      return {
        errorMessage: message,
        showSuccessSwal: false,
      };
    },
    getProductName() {
      this.handleProductLoading();
      this.makeProductRequest();
    },
    handleProductLoading() {
      this.productLoading = !this.productLoading;
    },
    makeProductRequest() {
      this.callService(
        this.requestProduct.get(
          this.getProductId,
        ),
        this.setProductName,
        this.makeSwalConfig(
          'Falha ao buscar nome do produto!',
        ),
      );
    },
    setProductName(response) {
      this.handleProductLoading();
      if (this.hasData(response)) {
        this.productName = response.data.nomProdutoServico;
      } else {
        this.productName = this.getProductId;
      }
    },
    getUserName() {
      this.handleUserLoading();
      this.makeUserRequest();
    },
    handleUserLoading() {
      this.userLoading = !this.userLoading;
    },
    makeUserRequest() {
      this.callService(
        this.requestUser.get(
          this.getUserId,
        ),
        this.setUserName,
        this.makeSwalConfig(
          'Falha ao buscar nome do usuário!',
        ),
      );
    },
    setUserName(response) {
      console.log(response);
      this.handleUserLoading();
      if (this.hasData(response)) {
        this.userName = response.data.username;
      } else {
        this.userName = this.getUserId;
      }
    },
    handleLoading(value) {
      this.loading = value;
    },
  },
  provide() {
    return {
      setDataLoading: (v) => {
        this.handleLoading(v);
      },
    };
  },
};
</script>
